<div class="container page-container process-cancellation-container">

  <div class="page-header">
    <h1>{{ 'TRANSLATE.CONTRACT.CANCELLATION' | translate }}</h1>
    <p class="subtitle">{{ 'TRANSLATE.CONTRACT.CANCELLATION.REQUESTS' | translate }}</p>
  </div>

  <div class="process-cancellation-body">
    <p-card class="process-cancellation-main-card">
      <p-header class="process-main-header">
        <div class="process-main-heading">
          <div class="p-card-title title-left process-main-title">
            {{ 'TRANSLATE.PROCESS.CANCELLATION' | translate }}
          </div>
          <div class="p-card-subtitle subtitle-left process-main-subtitle">
            {{ contractDetails.contractNumber }} • {{ contractDetails.chassi }}
          </div>
        </div>
        <hr class="hr-margin-top">
      </p-header>
      <form class="process-cancellation-form">

        <!-- Section 1: Plan Details (no changes) -->
        <p-card class="mb-4 section-block section-block--plan">

          <p-header>
            <div class="p-card-title space-left-two section-title-align">{{ 'TRANSLATE.PLAN.DETAILS' | translate }}
            </div>
          </p-header>
          <div class="section-content-box section-content-box--plan">
            <div class="grid plan-details">
              <div class="col-12 md:col-2 mb-2 detail-box plan">
                <span>{{ 'TRANSLATE.PLAN' | translate }}</span>
                <strong>{{ contractDetails.planName }}</strong>
              </div>
              <div class="col-12 md:col-2 mb-2 detail-box price">
                <span>{{ 'TRANSLATE.FINAL.PRICE' | translate }}</span>
                <strong>{{ contractDetails.finalPrice | currency:'BRL':'symbol':'1.2-2' }}</strong>
              </div>
              <div class="col-12 md:col-2 mb-2 detail-box debit">
                <span>{{ 'TRANSLATE.DEBIT.FORD' | translate }}</span>
                <strong>{{ contractDetails.fordDebit | currency:'BRL':'symbol':'1.2-2' }}</strong>
              </div>
              <div class="col-12 md:col-2 mb-2 detail-box sale-date">
                <span>{{ 'TRANSLATE.SALE.DATE.TABLE' | translate }}</span>
                <strong>{{ contractDetails.saleDate | date:'dd/MM/yyyy' }}</strong>
              </div>
              <div class="col-12 md:col-2 mb-2 detail-box contract-start">
                <span>{{ 'TRANSLATE.CONTRACT.START' | translate }}</span>
                <strong>{{ contractDetails.contractStartDate | date:'dd/MM/yyyy' }}</strong>
              </div>
            </div>
          </div>
        </p-card>

        <!-- Section 2: Consumption and Adjustments -->
        <p-card class="mb-4 section-block section-block--consumption">
          <p-header>
            <div class="p-card-title space-left-two section-title-align">
              {{ 'TRANSLATE.CONSUMPTION.ADJUSTMENTS' | translate }}
            </div>
          </p-header>
          <div class="section-content-box section-content-box--consumption">
            <div class="field col-12 md:col-4 date-space">
              <label for="cancellationDateProcess" class="title-icon">
                {{ 'TRANSLATE.CANCELLATION.REQUEST.DATE' | translate }}
                <i class="pi pi-calendar" style="font-size: 1rem"></i>
              </label>
              <input class="input-disabled" id="cancellationDateProcess"
                [value]="cancellationForm.cancellationDate | date:'dd/MM/yyyy'" type="text" disabled="true" pInputText>
            </div>

            <div class="grid gap-0 mt-4 consumption-table">
              <!-- Table Header -->
              <div class="col-2 table-header"></div>
              <div class="col-2 table-header">{{ 'TRANSLATE.TOTAL.CONTRACTED' | translate }}</div>
              <div class="col-3 table-header">{{ 'TRANSLATE.CONSUMED' | translate }}</div>
              <div class="col-2 table-header">{{ 'TRANSLATE.BALANCE' | translate }}</div>
              <div class="col-3 table-header">{{ 'TRANSLATE.RESIDUAL.VALUE' | translate }}</div>

              <!-- Months Row -->
              <div class="col-2 table-label">{{ 'TRANSLATE.MONTHS' | translate }}</div>
              <div class="col-2 table-value">{{ cancellationForm.totalMonths | number:'1.0-0' }}</div>
              <div class="col-3 table-input">
                <input id="months" type="text" name="consumedMonths" [value]="_consumedMonthsDisplay"
                  (input)="onInputMonths($event)" (blur)="onBlurMonths()" maxlength="5" pInputText
                  [ngClass]="{'ng-invalid': consumedMonthsError}">
                @if (consumedMonthsError) {
                <div class="error-message">
                  {{ consumedMonthsError }}
                </div>
                }
              </div>
              <div class="col-2 table-value">{{ cancellationForm.balanceMonths | number:'1.0-0' }}</div>
              <div class="col-3 table-value">
                {{ cancellationForm.residualValueMonths | currency:'BRL':'symbol':'1.2-2' }}
              </div>

              <!-- Visits Row -->
              <div class="col-2 table-label">{{ 'TRANSLATE.VISIT' | translate }}
                <i class="pi pi-info-circle" pTooltip="{{ 'TRANSLATE.SEE.SCHEDULE.OWS' | translate }}"
                  tooltipStyleClass="blue-tooltip-arrow" tooltipPosition="bottom"></i>
              </div>
              <div class="col-2 table-value">{{ cancellationForm.totalVisits | number:'1.0-0' }}</div>
              <div class="col-3 table-input">
                <input id="visits" type="text" name="consumedVisits" [value]="_consumedVisitsDisplay"
                  (input)="onInputVisits($event)" (blur)="onBlurVisits()" maxlength="2" pInputText
                  [ngClass]="{'ng-invalid': consumedVisitsError}">
                @if (consumedVisitsError) {
                <div class="error-message">
                  {{ consumedVisitsError }}
                </div>
                }
              </div>
              <div class="col-2 table-value">{{ cancellationForm.balanceVisits | number:'1.0-0' }}</div>
              <div class="col-3 table-value">
                {{ cancellationForm.residualValueVisits | currency:'BRL':'symbol':'1.2-2' }}
              </div>

              <!-- Mileage Row -->
              <div class="col-2 table-label">{{ 'TRANSLATE.MILEAGE' | translate }}</div>
              <div class="col-2 table-value">
                {{ cancellationForm.totalMileage | number:'1.0-0' }} km
              </div>
              <div class="col-3 table-input">
                <input id="mileage" type="text" name="consumedMileage" [value]="_consumedMileageDisplay"
                  (input)="onInputMileage($event)" (blur)="onBlurMileage()" maxlength="7" pInputText
                  [ngClass]="{'ng-invalid': consumedMileageError}">
                @if (consumedMileageError) {
                <div class="error-message">
                  {{ consumedMileageError }}
                </div>
                }
              </div>

              <div class="col-2 table-value">
                {{ cancellationForm.balanceMileage | number:'1.0-0' }}
              </div>
              <div class="col-3 table-value">
                {{ cancellationForm.residualValueMileage | currency:'BRL':'symbol':'1.2-2' }}
              </div>
            </div>

            <p-card class="mt-4 residual-final-card"
              [style]="{'border': '1px solid #F8F0E5', 'overflow': 'hidden', 'background': '#FEFCFA', 'border-radius': '10px'}">
              <p-header>
                <div class="p-card-title title-left residual-title-align">
                  {{ 'TRANSLATE.RESIDUAL.FINAL.VALUE' | translate }}
                </div>
                <div class="p-card-subtitle-two subtitle-left residual-subtitle-align">
                  {{ 'TRANSLATE.RESIDUAL.FINAL.VALUE.DESCRIPTION' | translate }}
                </div>
              </p-header>
              <input id="residualValue" type="text" name="finalResidualValue" [value]="_finalResidualValueDisplay"
                (input)="onInputFinalResidualValue($event)" (blur)="onBlurFinalResidualValue()" maxlength="13"
                pInputText [ngClass]="{'ng-invalid': finalResidualValueError}">
              @if (finalResidualValueError) {
              <div class="error-message">
                {{ finalResidualValueError }}
              </div>
              }
            </p-card>
          </div>
        </p-card>

        <!-- Section 3: Cancellation Reason - IPCA - Rates -->
        <p-card class="mb-4 cancellation-reason-block">
          <p-header>
            <div class="p-card-title space-left-two section-title-align cancellation-reason-title">
              {{ 'TRANSLATE.CANCELLATION.REASON.IPCA.RATES' | translate }}
            </div>
          </p-header>
          <div class="content-style">

            <!-- Motivo do Cancelamento -->
            <div class="col-12 field">
              <div class="p-card-title-two title-left">
                {{ 'TRANSLATE.CANCELLATION.REASON' | translate }}
              </div>
              <div class="p-card-subtitle-three subtitle-left">
                {{ 'TRANSLATE.INFORMED.BY.DEALERSHIP' | translate }}
              </div>
              <input class="input-disabled input-cancellation" id="cancelReason"
                [value]="cancellationForm.cancellationReason" type="text" disabled="true" pInputText>
            </div>

            <!-- Observações -->
            <div class="col-12 field mt-3">
              <label for="observationsProcess" class="p-card-title-two title-left">
                {{ 'TRANSLATE.ADDITIONAL.REMARKS' | translate }}
              </label>
              <textarea class="element-textarea" id="observationsProcess" name="additionalObservations"
                [(ngModel)]="cancellationForm.additionalObservations"
                (ngModelChange)="onAdditionalObservationsChange($event)" (blur)="onBlurAdditionalObservations()"
                minlength="2" maxlength="500" pInputTextarea
                [ngClass]="{'ng-invalid': additionalObservationsError}"></textarea>
              <div class="char-counter">
                {{ cancellationForm.additionalObservations?.length || 0 }}
                {{ 'TRANSLATE.MAX.CHARACTERS.500' | translate }}
              </div>
              @if (additionalObservationsError) {
              <div class="error-message">
                {{ additionalObservationsError }}
              </div>
              }
            </div>

            <!-- Emails -->
            <div class="grid mt-3 position">
              <div class="col-12 md:col-5 field position-two">
                <label for="dealerEmailProcess">
                  {{ 'TRANSLATE.DEALERSHIP.EMAIL' | translate }}
                </label>
                <input class="input-email" id="dealerEmailProcess" name="dealerEmail"
                  [(ngModel)]="cancellationForm.dealerEmail" (ngModelChange)="onDealerEmailChange($event)"
                  (blur)="onBlurDealerEmail()" placeholder="{{ 'TRANSLATE.ENTER.EMAIL' | translate }}" maxlength="80"
                  minlength="2" type="email" pInputText [ngClass]="{'ng-invalid': dealerEmailError}">
                @if (dealerEmailError) {
                <div class="error-message">
                  {{ dealerEmailError }}
                </div>
                }
              </div>
              <div class="col-12 md:col-5 field position-two">
                <label for="sellerEmailProcess">
                  {{ 'TRANSLATE.SELLER.EMAIL' | translate }}
                </label>
                <input class="input-email" id="sellerEmailProcess" name="sellerEmail"
                  [(ngModel)]="cancellationForm.sellerEmail" (ngModelChange)="onSellerEmailChange($event)"
                  (blur)="onBlurSellerEmail()" placeholder="{{ 'TRANSLATE.ENTER.EMAIL' | translate }}" maxlength="80"
                  minlength="2" type="email" pInputText [ngClass]="{'ng-invalid': sellerEmailError}">
                @if (sellerEmailError) {
                <div class="error-message">
                  {{ sellerEmailError }}
                </div>
                }
              </div>
            </div>

            <!-- IPCA e Taxas -->
            <div class="mt-3">
              <div class="p-card-title-two title-left">
                {{ 'TRANSLATE.IPCA.RATES' | translate }}
              </div>
              <div class="p-card-subtitle-three subtitle-left">
                <!--TODO As datas devem vir do DB -->
                {{ 'TRANSLATE.IPCA.ACCUMULATED' | translate }} 19/05/2024
                {{ 'TRANSLATE.UP.TO' | translate }} 26/11/2025
              </div>
              <div class="grid items-center position mt-2">
                <div class="col-12 md:col-5 field position-two">
                  <label for="ipcaPercentageProcess">
                    {{ 'TRANSLATE.IPCA.PERCENTAGE' | translate }}
                  </label>
                  <input class="ipca-and-rates" id="ipcaPercentageProcess" type="text" name="ipcaPercentage"
                    [value]="_ipcaPercentageDisplay" (input)="onInputIpcaPercentage($event)"
                    (blur)="onBlurIpcaPercentage()" maxlength="6" pInputText
                    [ngClass]="{'ng-invalid': ipcaPercentageError}">
                  @if (ipcaPercentageError) {
                  <div class="error-message">
                    {{ ipcaPercentageError }}
                  </div>
                  }
                </div>
                <div class="col-12 md:col-5 field position-two space-rates">
                  <label for="admTaxProcess">
                    {{ 'TRANSLATE.ADMINISTRATIVE.FEE' | translate }}
                  </label>
                  <input class="ipca-and-rates" id="admTaxProcess" type="text" name="admTax"
                    [value]="_administrativeTaxDisplay" (input)="onInputAdministrativeTax($event)"
                    (blur)="onBlurAdministrativeTax()" maxlength="13" pInputText
                    [ngClass]="{'ng-invalid': administrativeTaxError}">
                  @if (administrativeTaxError) {
                  <div class="error-message">
                    {{ administrativeTaxError }}
                  </div>
                  }
                </div>
              </div>
            </div>

          </div>
        </p-card>

        <!-- Section 5: Summary of Values -->
        <p-card class="mb-4">
          <p-header>
            <div class="p-card-title space-left-two section-title-align">{{ 'TRANSLATE.SUMMARY.OF.VALUES' | translate }}
            </div>
          </p-header>

          <div class="content-style-blue">

            <div class="value-summary">

              <div class="col-12 summary-item subtitle-left">
                <span>{{ 'TRANSLATE.DETAILS.OF.CALCULATION' | translate }}</span>
              </div>

              <div class="summary-rows">

                <div class="summary-position">

                  <div class="summary-item">
                    <span>{{ 'TRANSLATE.RESIDUAL.FINAL.VALUE.MIN' | translate }}</span>
                  </div>
                  <div class="summary-item positive">
                    <span>
                      {{ 'TRANSLATE.IPCA.CORRECTION' | translate }}
                      ({{ cancellationForm.ipcaPercentage | number:'1.2-2' }}%)
                    </span>
                  </div>
                  <div class="summary-item negative">
                    <span>{{ 'TRANSLATE.ADMINISTRATIVE.FEE.MINUS' | translate }}</span>
                  </div>
                </div>

                <div class="summary-position value-right">

                  <div class="summary-item value">
                    {{ cancellationForm.finalResidualValue | currency:'BRL':'symbol':'1.2-2' }}
                  </div>

                  <div class="summary-item value positive">
                    {{ calculatedValues.ipcaCorrection | currency:'BRL':'symbol':'1.2-2' }}
                  </div>

                  <div class="summary-item value negative">
                    {{ cancellationForm.administrativeTax | currency:'BRL':'symbol':'1.2-2'}}
                  </div>
                </div>
              </div>
            </div>

            <div class="grid gap-0 mt-4 total-value-box">

              <div class="return-component">
                <div class="col-8 return-label">
                  <i class="pi pi-check-circle icon-style"></i>
                  <p class="p-return-value">
                    {{ 'TRANSLATE.CUSTOMER.REFUND.VALUE' | translate }}
                  </p>
                </div>
                <div class="col-4 strong-return-value">
                  <strong>
                    {{ calculatedValues.customerReturn | currency:'BRL':'symbol':'1.2-2' }}
                  </strong>
                </div>
              </div>
            </div>

            <div class="return-position">

              @if (calculatedValues.isInvalidReturn) {
              <div class="grid gap-0 mt-4 items-center return-value-box"
                [ngClass]="{'invalid-value-box': calculatedValues.isInvalidReturn}">
                <div class="col-8 return-label">
                  <i class="pi pi-exclamation-triangle"></i>
                  <span>{{ 'TRANSLATE.INVALID.VALUE' | translate }}</span>
                </div>
                <div class="col-4 return-value">
                  <strong>
                    {{ 'TRANSLATE.CUSTOMER.RETURN.EXCEEDS' | translate }}
                    ({{ calculatedValues.customerReturn | currency:'BRL':'symbol':'1.2-2' }})
                    {{ 'TRANSLATE.CUSTOMER.RETURN.EXCEEDS.DESCRIPTION' | translate }}
                    ({{ contractDetails.finalPrice | currency:'BRL':'symbol':'1.2-2' }}).
                  </strong>
                </div>
              </div>
              }
            </div>

            <div class="distribution-boxes">
              <div class="distribution-box ford">
                <span>{{ 'TRANSLATE.FORD.REFUND' | translate }}</span>
                <strong>
                  {{ calculatedValues.fordReturn | currency:'BRL':'symbol':'1.2-2' }}
                </strong>
                <span class="percentage color-ford">80%</span>
              </div>
              <div class="distribution-box dealer">
                <span>{{ 'TRANSLATE.DEALER.REFUND' | translate }}</span>
                <strong>{{ calculatedValues.dealerReturn | currency:'BRL':'symbol':'1.2-2'
                  }}</strong>
                <span class="percentage color-dealer">20%</span>
              </div>
            </div>

          </div>
          <!-- Action Buttons -->
          <div class="flex items-center col-12 md:col-12 lg:col-12 button-position">
            <div>
              <button id="btnPrint" class="undo-action-button" type="button" (click)="goBack()">
                <span class="undo-action-button-label">
                  {{ 'TRANSLATE.PRINT' | translate }}
                </span>
              </button>
            </div>
            <div>
              <button id="btnReturn" class="undo-action-button" type="button" (click)="goBack()">
                <span class="undo-action-button-label">
                  {{ 'TRANSLATE.RETURN' | translate }}
                </span>
              </button>
              <button id="btnSave" class="action-button" type="button" (click)="confirmCancellation()">
                <span class="action-button-label">
                  {{ 'TRANSLATE.CONFIRM.CANCELLATION' | translate }}
                </span>
              </button>
            </div>
          </div>
        </p-card>

      </form>
    </p-card>
  </div>

</div>